import React from 'react';
import { Services } from './../../components';
import './services-view.css';

let services = [
    {
        title: 'کسب‌و‌کار و تجارت',
        description: 'مجموعه راهکارهای ارائه شده سرویس نقشه مپ بر اساس نوع کسب‌وکار.',
        image: 'business-illustration'
    },
                        {
                            title: 'سرویس‌ها',
                            description: 'مجموعه راهکارهای ارائه شده سرویس نقشه مپ بر اساس سرویس نقشه مورد استفاده.',
                            image: 'services-illustration'
                        }
]

export default function () {
    return (
        <div className="services-wrapper">
            <Services list={services} />
        </div>
    )
}